<footer>
    <div class="row relative h-27">
        <ng-container *ngIf="logoSrc">
            <div class="flex flex-col items-center justify-start service-provider ml-10x z-100  overflow-align-service">
                <div>Service Provided by</div>
                <div class="ml-2 service-provider-logo">
                    <a [href]="loginResponse?.serviceProviderUrl" target="_blank">
                        <img [src]="logoSrc" class="mt-2" #img alt="logo">
                    </a>
                </div>
            </div>
        </ng-container>

        <div *ngIf="!loginResponse?.whiteLabelEnabled" class="flex flex-row items-center company-info w-100 h-27 absolute justify-center">
            <p>
                <span class="px-0.1">
                    <span>&#xA9;</span>
                    Greytip Software Pvt.Ltd
                </span>
                <a target="_blank" [href]="hrPolicyHref" class="px-0.1" target="_blank">
                    Privacy Policy
                </a>
                <a target="_blank" [href]="hrTermHref" class="px-0.1" target="_blank">
                    Terms of Service
                </a>
            </p>
        </div>
    </div>
</footer>
